// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__IYLUf","calendarEvents":"styles_calendarEvents__kA8I8","day":"styles_day__B0etN","dayLabel":"styles_dayLabel__bzQP9"};